import React from "react";
import { Typography } from "@mui/material";
import { paragraphStyle } from "../../../../calculatorStyle";
import { stepFourData } from "../../eligibilityCalculatorData";
import { paragraphStyleOL } from "../../../../calculatorStyleData";

const StepFour = () => {
  return (
    <>
      <div className="mt-3">
        <div className="  d-flex flex-column gap-2">
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepFourData[0].heading}
          </Typography>
          <Typography sx={paragraphStyle}>{stepFourData[0].subhead}</Typography>

          <div>
            <ol style={paragraphStyleOL} className=" archivo">
              {stepFourData[0].infoList &&
                stepFourData[0].infoList.map((item, index) => (
                  <li key={index} className="mt-2">
                    <Typography sx={paragraphStyle}>
                      <strong> {item.heading}</strong>
                      <br />
                      {item.description}
                    </Typography>
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <div className=" mt-2 d-flex flex-column gap-2">
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepFourData[0].headTwo}
          </Typography>

          <div>
            <ol style={paragraphStyleOL} className=" archivo ">
              {stepFourData[0].headTwoInfoList &&
                stepFourData[0].headTwoInfoList.map((item, index) => (
                  <li key={index} className="mt-1">
                    <Typography sx={paragraphStyle}>
                      <strong> {item.heading}</strong>

                      {item.description}
                    </Typography>
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <div className=" mt-2 d-flex flex-column gap-2">
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepFourData[0].Tips}
          </Typography>
          <Typography sx={paragraphStyle}>
            {stepFourData[0].tipsSubhead}
          </Typography>

          <div>
            <ol style={paragraphStyleOL} className=" archivo ">
              {stepFourData[0].tipsInfoList &&
                stepFourData[0].tipsInfoList.map((item, index) => (
                  <li key={index} className="mt-1">
                    <Typography sx={paragraphStyle}>
                      <strong> {item.heading}</strong>
                      <br />
                      {item.description}
                    </Typography>
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <div id="buying_journey" className="d-flex flex-column gap-2 mb-2">
          <Typography sx={paragraphStyle}>{stepFourData[1].paraOne}</Typography>
          <Typography sx={paragraphStyle}>{stepFourData[1].paraTwo}</Typography>

          <Typography sx={paragraphStyle}>
            {stepFourData[1].paraThree}
          </Typography>
        </div>
      </div>
    </>
  );
};

export default StepFour;
